module.exports = __webpack_public_path__ + "img/compact.05c91cdf.png";